/* 單獨列傳：關張傳（設計見 docs/CAMPAIGN-GUANZHANG.md）
 * 這一條列傳自己的章節、地圖都在這個檔案登錄，不用改 campaign/index.ts。
 * 地圖 id 一律加前綴「guanzhang_」，免得和其他列傳撞名。 */
// @ts-nocheck
import guanzhang1 from '../story/guanzhang1.ts';
import guanzhang2 from '../story/guanzhang2.ts';
import guanzhang3 from '../story/guanzhang3.ts';
import guanzhang4 from '../story/guanzhang4.ts';
import guanzhang5 from '../story/guanzhang5.ts';
import guanzhang_jiangzhou from '../maps/guanzhang_jiangzhou.ts';
import guanzhang_dangqu from '../maps/guanzhang_dangqu.ts';
import guanzhang_jiangling_ying from '../maps/guanzhang_jiangling_ying.ts';
import guanzhang_fan from '../maps/guanzhang_fan.ts';
import guanzhang_maicheng from '../maps/guanzhang_maicheng.ts';

export default {
  list: { id: 'guanzhang', name: '關張傳', years: '214–221', parts: [
    { name: '張飛篇', chapters: ['guanzhang-1', 'guanzhang-2'] },
    { name: '關羽篇', chapters: ['guanzhang-3', 'guanzhang-4', 'guanzhang-5'] },
  ] },
  chapters: [guanzhang1, guanzhang2, guanzhang3, guanzhang4, guanzhang5],
  maps: { guanzhang_jiangzhou, guanzhang_dangqu, guanzhang_jiangling_ying, guanzhang_fan, guanzhang_maicheng },
};
